import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MfaData } from '../../const/models/mfa.model';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { getFormModel } from '../../const/data/mfa-data';
import { DomHelper } from '../../../../../helpers/dom.helper';
import { VerifyMfaCodeData } from '../../const/models/verify-mfa-code-data.model';
import { FormErrorsConditionOperator } from '../../../../../ui/enums/form-errors-condition-operator.enum';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MfaActionsInternalService } from '../../services/mfa-actions.internal.service';
import { MfaErrorCodeType } from '../../const/enums/mfa-error-code-type.enum';
import { MessageService } from "../../../../../../core/message/message.service";

@UntilDestroy()
@Component({
    selector: 'ifc-mfa-auth-app-content',
    templateUrl: './mfa-auth-app-content.component.html',
    styleUrls: ['./mfa-auth-app-content.component.scss'],
    standalone: false
})
export class MfaAuthAppContentComponent implements OnInit {
  data: MfaData;
  @Input() set mfaData(data: MfaData) {
    this.data = data;
  }

  @Output()
  verify = new EventEmitter<VerifyMfaCodeData>();

  form: UntypedFormGroup;
  codeMask: string;

  readonly ConditionOperator = FormErrorsConditionOperator;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly mfaActions: MfaActionsInternalService,
    private readonly messageService: MessageService) { 
    this.initForm();
  }

  ngOnInit(): void {
    this.codeMask = this.getCodeMask(this.data.mfaCodeData.codeLength);

    this.initActions();
  }

  copy(): void {
    DomHelper.copy(this.data.mfaTotpSecret);
    this.messageService.info(`Secret copied`);
  }

  onClickVerify(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const formValues = this.form.value;
    const data: VerifyMfaCodeData = {
      mfaData: this.data,
      mfaCode: formValues["code"]
    };

    if(this.data.config.isTrustingDeviceAllowed) {
      data.trustDevice = formValues["trustDevice"]
    };

    this.verify.emit(data);
  }

  private initActions(): void {
    this.form.controls["code"].valueChanges
      .pipe(untilDestroyed(this))
      .subscribe(() => this.clearInvalidCodeError());

    this.mfaActions.invalidCode$.pipe(untilDestroyed(this)).subscribe(() => {
      this.setInvalidCodeError();
    });
  }

  private clearInvalidCodeError(): void {
    if (this.form.controls["code"].hasError(MfaErrorCodeType.InvalidMfaCode)) {
      delete this.form.controls["code"].errors?.[
        MfaErrorCodeType.InvalidMfaCode
      ];
    }
  }

  private setInvalidCodeError(): void {
    this.form.controls["code"].setErrors({
      ...this.form.controls["code"].errors,
      [MfaErrorCodeType.InvalidMfaCode]: true,
    });
  }

  private getCodeMask(codeLength: number): string {
    return "0".repeat(codeLength);
  }

  private initForm(): void {
    this.form = this.formBuilder.group(getFormModel);
  }
}
